import type { ComputedRef, Ref } from 'vue';
enum CookieConsentCategory {
  NOT_REQUIRED = 'notRequired',
}

enum CookieConsentDecision {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

type CookieConsentStorage = {
  notRequiredCookieConsent: Ref<CookieConsentDecision | null>;
  setNotRequiredCookieConsent: (decision: CookieConsentDecision) => void;
};

type CookieConsentController = {
  decision: Readonly<Ref<CookieConsentDecision | null>>;
  isAllowed: (category: CookieConsentCategory) => boolean;
  isChoiceRequired: Readonly<ComputedRef<boolean>>;
  isNotRequiredAllowed: Readonly<ComputedRef<boolean>>;
  acceptNotRequired: () => void;
  rejectNotRequired: () => void;
};

export {
  CookieConsentCategory,
  CookieConsentDecision,
  type CookieConsentController,
  type CookieConsentStorage,
};
